import {
    ActionIcon,
    Group,
    Menu,
    Tooltip,
    UnstyledButton,
    rem,
} from '@mantine/core';
import { IconChartDots2, IconPencil, IconRefresh } from '@tabler/icons-react';

import useRefreshDataFile from '../../../../../http/mutations/data/useRefreshDataFile';

const ActionsColumn = ({ row: { original: rowData }, handleTimeline }) => {
    const { isPending: refreshPending, mutate: refreshFile } =
        useRefreshDataFile();

    const handleStatRefresh = () => {
        if (refreshPending) {
            return;
        }

        refreshFile({
            id: rowData.id,
            action: 'stats',
        });
    };

    return (
        <Group gap={'xs'}>
            <Tooltip label={'Refresh stats'}>
                <ActionIcon
                    variant='default'
                    size={'sm'}
                    disabled={refreshPending}
                    onClick={handleStatRefresh}>
                    <IconRefresh size={16} />
                </ActionIcon>
            </Tooltip>
            <Tooltip label={'Send Timeline'}>
                <ActionIcon
                    variant='default'
                    size={'sm'}
                    onClick={() => handleTimeline(rowData)}>
                    <IconChartDots2 size={16} />
                </ActionIcon>
            </Tooltip>
        </Group>
    );
};
export default ActionsColumn;
